import { COMPANY, SERVICE_AREAS, SERVICES } from '../mock/data';

export default function About() {
  return (
    <section id="about" className="py-24 lg:py-32 bg-ink border-t border-white/5">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="max-w-2xl">
          <div className="eyebrow">About the Company</div>
          <h2 className="section-title">Local, insured, and built on referrals.</h2>
        </div>

        <div className="mt-10 grid md:grid-cols-2 gap-10 text-cream/75 leading-relaxed">
          <div className="space-y-4">
            <p>
              Better Fence &amp; Deck is a locally owned fence contractor based in {COMPANY.city}, serving homeowners and businesses across the ArkLaTex. We build every fence and deck the way we&rsquo;d build it for our own family &mdash; straight, plumb, tight, and finished cleaner than we found the yard.
            </p>
            <p>
              The name says it all. Whatever the other guys can do, we do better. Better wood. Better hardware. Better crews. Better warranty. Better follow-through on the small stuff that most contractors skip &mdash; caps aligned, posts set to depth in concrete, gates that swing true a year later.
            </p>
            <p>
              We stand behind every job with a written warranty on labor. If something isn&rsquo;t right, we come back and make it right &mdash; no arguing, no runaround.
            </p>
          </div>

          <div className="space-y-4">
            <p>
              <strong className="text-cream">Materials we build with.</strong> Premium Western Red Cedar and pressure-treated Southern Yellow Pine for wood fences; commercial-grade vinyl with lifetime material warranties; galvanized and vinyl-coated steel chain-link; powder-coated aluminum and iron for ornamental work; and Trex, TimberTech, and treated Southern Pine for decks.
            </p>
            <p>
              <strong className="text-cream">Hardware matters.</strong> We use hot-dipped galvanized or stainless nails and screws, heavy-duty commercial gate hardware, and 4x4 or 6x6 posts set in concrete below the frost line so your fence stays plumb through Louisiana rain, wind, and clay soil.
            </p>
            <p>
              <strong className="text-cream">Free written estimates.</strong> Every quote is on-site, in writing, and no-obligation. We measure, discuss materials and layout, walk the property, and hand you a detailed proposal you can take to your HOA or insurance company.
            </p>
          </div>
        </div>

        {/* Materials guide — adds real crawlable content */}
        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => (
            <div key={s.id} className="rounded-md border border-white/10 bg-ink-panel p-5">
              <h3 className="font-display uppercase text-lg text-cream tracking-tight">{s.title}</h3>
              <p className="mt-2 text-sm text-cream/70 leading-relaxed">{s.blurb}</p>
              <ul className="mt-3 space-y-1.5 text-sm text-cream/65">
                {s.features.map((f) => (
                  <li key={f} className="flex items-start gap-2">
                    <span className="w-1 h-1 bg-gold rounded-full mt-2 shrink-0" />
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-3 text-[11px] uppercase tracking-widest text-gold">Starting at {s.from}</div>
            </div>
          ))}
        </div>

        {/* Local expertise section for local SEO */}
        <div className="mt-16 rounded-md border border-white/10 bg-ink-panel p-6 md:p-8">
          <h3 className="font-display uppercase text-2xl text-cream tracking-tight">Serving the ArkLaTex</h3>
          <p className="mt-3 text-cream/70 leading-relaxed">
            We work daily across northwest Louisiana and east Texas. Whether you&rsquo;re a homeowner in an established Shreveport neighborhood, building new construction in Bossier City, need a farm perimeter fence outside Mansfield, or want a covered porch added to a lake house near Longview, we&rsquo;ve got a crew and a plan for your yard.
          </p>
          <p className="mt-3 text-cream/70 leading-relaxed">
            Our regular service area includes {SERVICE_AREAS.join(', ')}, and the small towns in between. If you&rsquo;re just outside this list, call us anyway &mdash; we regularly travel for larger jobs.
          </p>
          <p className="mt-3 text-cream/70 leading-relaxed">
            Weather in the ArkLaTex is brutal on fences &mdash; humid summers, freezing rain, tornado-strength wind gusts, and heavy red clay that grabs and doesn&rsquo;t let go. Every material we recommend has been chosen for how it performs specifically in this climate, not for national marketing brochures. Cedar over pine on premium jobs. Vinyl-coated over galvanized-only in wet-yard installs. 6-foot posts in 3-foot holes with concrete, always.
          </p>
        </div>

        {/* Contact CTA */}
        <div className="mt-14 flex flex-col md:flex-row items-center justify-between gap-4 p-6 rounded-md bg-gold text-ink">
          <div>
            <div className="font-display uppercase text-2xl tracking-tight">Ready for a free estimate?</div>
            <p className="mt-1 text-ink/80 text-sm">Call, text, or fill the quote form. Most estimates scheduled within 24 hours.</p>
          </div>
          <div className="flex gap-3">
            <a href={`tel:${COMPANY.phoneRaw}`} className="inline-flex items-center gap-2 rounded-md bg-ink text-cream px-5 py-3 font-bold uppercase tracking-wider text-sm hover:bg-ink-soft transition-colors">
              Call {COMPANY.phone}
            </a>
            <a href="#quote" className="inline-flex items-center gap-2 rounded-md border-2 border-ink text-ink px-5 py-3 font-bold uppercase tracking-wider text-sm hover:bg-ink hover:text-cream transition-colors">
              Get Quote
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
